module.exports = __webpack_public_path__ + "img/enterIcon.81809c01.svg";